import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./ServiceDetailLayout.css";

export default function ServiceDetailLayout({ title, summarySections, snapshot, children }) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const backTo = state?.from || "/services";
  const backLabel = backTo === "/" ? "Retour à l'accueil" : "Retour aux services";
  const [activeSection, setActiveSection] = useState(summarySections[0]?.id || "");

  useEffect(() => {
    const sectionEls = summarySections
      .map(s => document.getElementById(s.id))
      .filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter(e => e.isIntersecting);
        if (visible.length > 0) {
          setActiveSection(visible[0].target.id);
        }
      },
      { rootMargin: "-15% 0px -75% 0px", threshold: 0 }
    );

    sectionEls.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [summarySections]);

  return (
    <div className="service-detail-global">
      <div className="service-detail-header-row">
        <button
          className="animated-back-btn"
          onClick={() => navigate(backTo)}
        >
          <span aria-hidden="true" style={{ marginRight: 8 }}>←</span>
          {backLabel}
        </button>
        <h1 className="service-detail-title">{title}</h1>
      </div>

      {snapshot && (
        <div className="service-snapshot">
          <div className="service-snapshot__item">
            <div className="service-snapshot__icon">💰</div>
            <div>
              <div className="service-snapshot__label">Prix</div>
              <div className="service-snapshot__value">{snapshot.price}</div>
            </div>
          </div>
          <div className="service-snapshot__divider" />
          <div className="service-snapshot__item">
            <div className="service-snapshot__icon">⏱</div>
            <div>
              <div className="service-snapshot__label">Delai</div>
              <div className="service-snapshot__value">{snapshot.delay}</div>
            </div>
          </div>
          <div className="service-snapshot__divider" />
          <div className="service-snapshot__item service-snapshot__item--idealfor">
            <div className="service-snapshot__icon">✓</div>
            <div>
              <div className="service-snapshot__label">Ideal pour</div>
              <div className="service-snapshot__value">{snapshot.idealFor}</div>
            </div>
          </div>
          <div className="service-snapshot__actions">
            <Link to="/devis" className="service-snapshot__cta">
              Devis gratuit &rarr;
            </Link>
            <Link to="/tarifs" className="service-snapshot__tarifs">
              Voir nos formules
            </Link>
          </div>
        </div>
      )}

      <div className="service-detail-layout">
        <aside className="service-summary">
          <div className="service-summary-title">Sommaire</div>
          <nav>
            <ul>
              {summarySections.map((section) => (
                <li key={section.id}>
                  <a
                    href={`#${section.id}`}
                    className={activeSection === section.id ? "active" : ""}
                  >
                    {section.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="service-sidebar-cta">
            <p className="service-sidebar-cta__title">Pret a demarrer ?</p>
            <Link to="/devis" className="service-sidebar-cta__btn">
              Demander un devis gratuit
            </Link>
            <Link to="/tarifs" className="service-sidebar-cta__tarifs-link">
              Voir nos formules et tarifs
            </Link>
            <a
              href="mailto:contact@nxs-solutions.com"
              className="service-sidebar-cta__wa"
            >
              Nous ecrire par email
            </a>
          </div>
        </aside>

        <article className="service-content">
          {children}
        </article>
      </div>
    </div>
  );
}
